<script lang="ts" setup>
import MsFoundationItems from '@/domains/esg/key-activities/components/MsFoundation/MsFoundationItems.vue'
import { useKeyActivities } from '@/domains/esg/composables/content/useKeyActivities'

const { msFoundationItems } = useKeyActivities()
</script>

<template>
  <UiSection
    id="fundacja-multisport"
    class="ms-foundation"
    color="white"
  >
    <div class="section__container">
      <div class="section__row">
        <div class="section__col">
          <img
            class="ms-foundation__logo"
            alt="Fundacja Multisport"
            src="/images/key-activities/ms-foundation-logo.png"
          >

          <UiHeader
            :header="''"
            :subheader="$t('keyActivities.foundation.text')"
          />

          <MsFoundationItems :items="msFoundationItems" />

          <UiButton
            class="ms-foundation__button"
            :to="$t('keyActivities.foundation.button.link')"
            :target="'_blank'"
          >
            {{ $t('keyActivities.foundation.button.text') }}
          </UiButton>
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.ms-foundation {
  padding-top: 3.2rem;
  padding-bottom: 3.2rem;

  &__logo {
    display: block;
    max-width: 256px;
    margin: 0 auto 3.2rem auto;
  }

  &__button {
    margin: 7.2rem auto 0;
  }

  @include atM {
    padding-top: 12rem;
    padding-bottom: 12rem;

    &__logo {
      max-width: unset;
    }
  }
}
</style>
